module.exports = __webpack_public_path__ + "img/HILO.71abe1b5.png";